import React from 'react';
import './success.css';
import { Link } from 'react-router-dom';
import { CelebrationFinal } from '../../../assets/icons';

const Success = () => {
    return (
        <div className='customContainer w-100 h-100'>
            <div className='popupContainer  lg:p-10 md:p-7 rounded-lg text-white'>
                <div className="headerContent flex items-center gap-2 w-auto mr-10  mb-[0.8rem]">
                    <img src={CelebrationFinal} className='h-16 w-16 flex' alt="celebration"/>
                    <h2 className='Syne700 header lg:text-5xl md:text-2xl'>Congratulations</h2>
                </div>
                <div className="para lg:text-lg md:text-sm p-3 lg:leading-7 md:leading-5 font-medium">
                    <p>
                        Thank you for entrusting us with your end credit needs.
                    </p>
                    <p>
                        We've emailed your receipt. With ScrollX, you're about to experience a
                    </p>
                    <p>
                     world of simplicity and efficiency in crafting beautiful and credits for your films.
                    </p>
                </div>
                <Link to="/" className='popup-btn px-3 py-2 rounded-2xl text-lg md:mt-2 lg:mt-4 text-black hover:scale-95 hover:ease-in duration-200'>Continue To Render</Link>
            </div>
        </div>
    )
}

export default Success